export default __webpack_public_path__ + "static/media/pic3.4f0a88d2.webp";